import { graphHooks } from '@tunasong/graph-lib/react'
import type { Entity, Persisted } from '@tunasong/schemas'
import { useRecent } from '@tunasong/search'
import { EntityGrid, EntityList, Typography, useDimensions, useNavigateToEntity } from '@tunasong/ui-lib'
import type { FC } from 'react'

export interface RecentProps {
  /** Entities to exclude from the list, e.g., if they are already shown */
  exclude?: Persisted<Entity>[]
  /** Title of the recent list */
  title?: string
  type?: 'grid' | 'list'
  /** Show recent activities for a specific parent entity */
  parentId?: string
  rows?: number
  size?: 'small' | 'medium' | 'large' | 'tiny'
}

export const RecentActivity: FC<RecentProps> = props => {
  const { exclude, title, type = 'list', parentId, rows = 2, size = 'medium' } = props
  const navigateToEntity = useNavigateToEntity()
  const { isTiny } = useDimensions()
  const steps = isTiny ? 2 : 3

  const maxCount = type === 'grid' ? rows * steps : 30

  const { isLoading: isSearching, searchResults } = useRecent({ exclude, maxCount, parentId })

  const entityIds = searchResults.slice(0, maxCount).map(e => e.id)
  const { existingEntities: entities, isLoading } = graphHooks.useEntitiesById(entityIds)

  const loading = (isSearching || isLoading) && entities.length === 0

  const filteredEntities = entities.filter(e => !e.trash).sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))

  return (
    <>
      {title ? <Typography variant="subtitle1">{title}</Typography> : null}
      {type === 'grid' ? (
        <EntityGrid
          style={{ paddingTop: 8, paddingBottom: 32 }}
          size={size}
          skeletonItems={maxCount}
          placeholder="No recent activities found"
          entities={filteredEntities}
          loading={loading}
          onOpen={navigateToEntity}
        />
      ) : (
        <EntityList
          style={{
            maxHeight: '40vh',
            overflowY: 'auto',
            paddingBottom: 96,
            maskImage: 'linear-gradient(to bottom, black 60%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, black 60%, transparent 100%)',
          }}
          showBreadcrumbs={'inactiveLinks'}
          entities={filteredEntities}
          onOpen={navigateToEntity}
          size={size}
          actions={false}
        />
      )}
    </>
  )
}
